<template>
  <div class="w-full">
    <RouterView></RouterView>
  </div>
</template>
